import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseLearningMemo } from '@/api/responses/study/studyLearnings'

export namespace StudyGeneralLearningMemosApi {
  /**
   * 通常授業サポート学習の演習メモ登録
   *
   * @param generalLearningId 演習結果ID
   * @param strokes ストローク情報(JSON文字列をデータ圧縮した値)
   */
  export async function postGeneralLearningMemo(generalLearningId: number, strokes: string): Promise<void> {
    const params = {
      strokes: strokes,
    }
    await ApiBase.post(`/study/generalLearnings/${generalLearningId}/memo`, params)
  }

  /**
   * 通常授業サポート学習の演習メモ取得
   *
   * @param generalLearningId 演習結果ID
   * @returns 演習メモ情報
   */
  export async function getGeneralLearningMemo(generalLearningId: number): Promise<ApiResponseLearningMemo> {
    return await ApiBase.get(`/study/generalLearnings/${generalLearningId}/memo`)
  }
}
